import React from "react";
import { TeamCardContainer, TeamPhoto, TeamH2, TeamCardP } from "./teamElements";
const TeamCard = ({ photo, alt, teamName, teamRole }) => {
  return (
    <TeamCardContainer>
      <TeamPhoto src={photo} alt={alt} />
      <TeamH2>{teamName}</TeamH2>
      <TeamCardP>{teamRole}</TeamCardP>
    </TeamCardContainer>
  );
};

export default TeamCard;
